import { RoleAutocomplete } from "@components/role/role-autocomplete/role-autocomplete";
import { RoleAutocompleteProps } from "@components/role/select-role-utils";
import { FaroCoreApiConst, FaroCoreApiTypes } from "@stellar/core-api-client";

/** Renders a dropdown to select project role */
export function ProjectRoleAutoComplete<
  T extends FaroCoreApiTypes.ProjectRole
>({
  selectedRole,
  onChange,
  onResetSelection,
  placeholder = "Select a role...",
  disabledRoles = [],
  isRequired,
}: RoleAutocompleteProps<T>): JSX.Element {
  return (
    <RoleAutocomplete
      labelTitle="Project role"
      isRequired={isRequired}
      selectedRole={selectedRole}
      onChange={onChange}
      onResetSelection={onResetSelection}
      placeholder={placeholder}
      roles={FaroCoreApiConst.allProjectRoles as T[]}
      disabledRoles={["RESOURCE_OWNER"].concat(disabledRoles) as T[]}
      link="projectRolesHelp"
      dataTestId="project-role-selector"
    />
  );
}
